import { useTranslation } from 'next-i18next';

import { alertDialog } from '@/ui_v3';

export const useShowAiErrorAlert = () => {
  const { t } = useTranslation(['build']);
  return () =>
    alertDialog.open({
      header: {
        title: t('build:ai.generate.failTitle'),
      },
      body: t('build:ai.generate.failDescription'),
    });
};
